import React from 'react';
import { Alert, Button, Modal, Typography } from 'antd';
import dayjs from 'dayjs';
import { WEEKDAY_LABELS } from './weekUtil';

export default function CommonSlotsPanel({ schedule, onConfirm }) {
  if (!schedule.all_submitted) {
    const doneCount = schedule.members.filter((m) => m.submitted).length;
    return (
      <Alert
        type="info"
        showIcon
        message={`아직 모든 인원이 제출하지 않았습니다 (${doneCount}/${schedule.members.length} 완료)`}
        style={{ marginTop: 16 }}
      />
    );
  }

  if (schedule.common_slots.length === 0) {
    return (
      <Alert
        type="warning"
        showIcon
        message="전원이 제출했지만 공통 가능 시각이 없습니다"
        style={{ marginTop: 16 }}
      />
    );
  }

  const byDate = {};
  schedule.common_slots.forEach((slot) => {
    if (!byDate[slot.date]) byDate[slot.date] = [];
    byDate[slot.date].push(slot.time.slice(0, 5));
  });

  const handleClick = (date, time) => {
    const d = dayjs(date);
    Modal.confirm({
      title: '레이드 시각 확정',
      content: `${d.format('YYYY-MM-DD')}(${WEEKDAY_LABELS[d.day()]}) ${time}으로 레이드 시각을 확정할까요?`,
      okText: '확정',
      cancelText: '취소',
      onOk: () => onConfirm(date, `${time}:00`),
    });
  };

  return (
    <div style={{ marginTop: 16 }}>
      <Typography.Title level={5}>공통 가능 시각 (출발 시각을 선택하세요)</Typography.Title>
      {Object.entries(byDate).map(([date, times]) => {
        const d = dayjs(date);
        return (
          <div key={date} style={{ marginBottom: 8 }}>
            <Typography.Text strong style={{ marginRight: 8 }}>
              {d.format('MM/DD')}({WEEKDAY_LABELS[d.day()]})
            </Typography.Text>
            {times.map((time) => (
              <Button
                key={time}
                size="small"
                style={{ margin: '2px 4px 2px 0' }}
                onClick={() => handleClick(date, time)}
              >
                {time}
              </Button>
            ))}
          </div>
        );
      })}
    </div>
  );
}
